<template>
	<v-dialog
		v-model="show"
		v-bind="$attrs"
		:max-width="computedMaxWidth"
		:transition="false"
		:fullscreen="$attrs.fullscreen === false ? false : $vuetify.breakpoint.mdAndDown"
	>
		<v-card tile>
			<v-card-title>
				<span>{{ title }}</span>
				<v-spacer />
				<v-btn @click="close" tabindex="-1" icon><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-card-subtitle v-if="subtitle || optionalSubtitle" class="mb-0 pb-1">
				<span v-if="subtitle">{{ subtitle }}</span>
				<slot v-if="optionalSubtitle" name="optionalSubtitleData"></slot>
			</v-card-subtitle>
			<v-card-text class="px-0">
				<slot></slot>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import i18n from './dictionary';

export default {
	name: 'SlotDialog',
	i18n,
	props: {
		value: Boolean,
		dialogWidth: {
			type: Number,
			default: 750,
		},
		title: {
			type: String,
			default: '',
		},
		subtitle: {
			type: String,
			required: false,
		},
		optionalSubtitle: {
			type: Boolean,
			default: false,
		},
		maxWidth: {
			type: Number,
			required: false,
		},
	},
	computed: {
		show: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
				if (!value) {
					//if there's a CrudEditor in the slot, trigger the cancel in the CrudEditor
					const tag = this.$_.get(this.$slots, 'default[0].componentOptions.tag');
					if (tag === 'crud-editor') {
						const editorComponent = this.$_.get(this.$slots, 'default[0].componentInstance');
						editorComponent.cancel();
					}

					this.$emit('close');
				}
			},
		},
		computedMaxWidth() {
			if (this.maxWidth) {
				return this.maxWidth;
			} else {
				return this.dialogWidth;
			}
		},
	},
	watch: {
		value() {
			if (!this.value) {
				const dialogs = document.getElementsByClassName('v-dialog--active');
				if (dialogs && dialogs.length) dialogs[dialogs.length - 1].scrollTop = 0;
			}
		},
	},
	methods: {
		close() {
			this.show = false;
			this.$emit('close');
		},
	},
};
</script>
